import dayjs from 'dayjs'

const dateDetailOrder = date => {
  return dayjs(String(date).substr(0, 19))
    .locale('es')
    .format('DD [de] MMMM [de] YYYY [a las] HH:mm')
}
export default dateDetailOrder
